import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@emotion/react';


export default function CustomTableClassFees(props) {
  // console.log(props)
const getDate = (value) => {
    const cleanValue = value?.replace(/(\d+)(st|nd|rd|th)/, '$1');

  const event = new Date(cleanValue);
// console.log(event)
  if (isNaN(event.getTime())) return value; // fallback if date is invalid
  const locale = 'fa-IR'
  if (locale === 'fa-IR') {
    const arr = ['دی', 'بهمن', 'اسفند', 'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر'];
    const convertmonths = ['جدی', 'دلو', 'حوت', 'حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس'];

    const getMonth = event.toLocaleDateString(locale, { month: 'long' });
    const currentDate = event.toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
    const getIndMonth = arr.indexOf(getMonth);
// console.log(getIndMonth)
    return currentDate.replace(getMonth, convertmonths[getIndMonth]);
  }

  return event.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

  const theme = useTheme();
  const style = theme.palette;
  // console.log(style.sidemenutext.secondary)
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 400 }} aria-label="caption table">
       <TableHead>
  <TableRow
    sx={{ background: style.primary.main }}
    id="thead"
    style={{
      backgroundColor:
        props.defaulters === 'yes'
          ? '#ff8383'
          : props.defaulters === 'removed'
          ? 'red'
          : null,
    }}
  >
    {props.data &&
      Object.keys(props.data[0])
        .filter((key) => key !== 'Approved') // ✅ correct filtering
        .map((key) => (
          <TableCell key={key} sx={{ color: style.sidemenutext.color }}>
            {key === 'Month'
              ? 'Month'
              : key === 'roll'
              ? 'Roll'
              : key === 'Srn'
              ? 'Srn.'
              : key === 'Date'
              ? 'Date'
              : key === 'Fees'
              ? 'Fees'
              : key === 'Discount'
              ? 'Discount'
              : key === 'StudentSrn'
              ? 'RollNumber'
              : key === 'StartDate'
              ? 'Start Date'
              : key === 'Name'
              ? 'Name'
              : key === 'Comments'
              ? 'Comments'
              : key === 'paidFees'
              ? 'Paid Fees'
              : key === 'Description'
              ? 'Description'
              : key === 'Dues'
              ? 'Dues'
              : key === 'Paid Amount'
              ? 'Paid Amount'
              : key === 'NamePashto'
              ? 'Name)'
              : key === 'FNamePashto'
              ? 'Father'
              : key === 'TellNo1'
              ? 'Mobile'
              : key === 'Ammount'
              ? 'Amount'
              : key}
          </TableCell>
        ))}
  </TableRow>
</TableHead>

        <TableBody>
  {props.data &&
    props.data.map((row, ind) => (
      <TableRow key={ind}>
        {Object.entries(row)
          .filter(([key]) => key !== 'Approved') // remove Approved before rendering
          .map(([key, value], index) => (
            <TableCell key={index}>{value}</TableCell>
          ))}
      </TableRow>
    ))}
</TableBody>

      </Table>
    </TableContainer>
  );
}
